module.exports = __webpack_public_path__ + "static/media/heart.ce4e6c42.svg";